<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入名称"  allow-clear />
      </a-form-model-item>
      <a-form-model-item label="icon" prop="icon" >
        <file-upload type="image" :defaultList="form.iconArr" :count="1"
                     @input="getImg($event, 'icon')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="所需树的数量" prop="treeNum" >
        <a-input-number :min="0"  style="width: 300px" v-model="form.treeNum" placeholder="请输入所需树的数量" />
      </a-form-model-item>
      <a-form-model-item label="树占比" prop="treeRatio" >
        <a-input-number :min="0" :max="100" style="width: 300px" v-model="form.treeRadio" placeholder="请输入树占比" />%
      </a-form-model-item>
      <a-form-model-item label="所需水滴数" prop="raindropNum" >
        <a-input-number :min="0" style="width: 300px" v-model="form.raindropNum" placeholder="请输入所需水滴数" />
      </a-form-model-item>
      <a-form-model-item label="水滴占比" prop="raindropRatio" >
        <a-input-number :min="0" :max="100" style="width: 300px" v-model="form.raindropRadio" placeholder="请输入水滴占比" />%
      </a-form-model-item>
      <a-form-model-item label="成长值" prop="growthValue" >
        <a-input-number style="width: 300px" :min="0"  v-model="form.growthValue" placeholder="请输入成长值" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getLevel, addLevel, updateLevel } from '@/api/forest/level'
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        name: null,
        icon: null,
        iconArr: [],
        iconCount: 1,
        treeNum: null,
        treeRadio:null,
        raindropNum: null,
        raindropRadio:null,
        growthValue:null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        treeNum: [
          { required: true, message: '所需树的数量不能为空', trigger: 'blur' }
        ],
        raindropNum: [
          { required: true, message: '所需水滴数不能为空', trigger: 'blur' }
        ],
        treeRadio: [
          { required: true, message: '树占比不能为空', trigger: 'blur' }
        ],
        raindropRadio: [
          { required: true, message: '水滴占比不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        icon: null,
        iconArr: [],
        iconCount: 1,
        treeNum: null,
        treeRadio:null,
        raindropNum: null,
        raindropRadio:null,
        growthValue:null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.open = true
      this.reset()
      this.formType = 1
      this.formTitle = '添加'
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.open = true
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLevel({"id":id}).then(response => {
        this.form = response.data
        this.formTitle = '修改'
        this.form.treeRadio = this.form.treeRadio*100
        this.form.raindropRadio = this.form.raindropRadio*100
        this.form.iconArr = []
        let that = this;
        if(this.form.icon){
          this.form.iconArr.push({
            uid: guid(8, 10),
            name: that.form.icon,
            status: 'done',
            halfUrl: that.form.icon,
            url: that.form.icon,
            path: that.form.icon
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          let radio = this.form.treeRadio+this.form.raindropRadio
          if(radio > 100){
            this.$message.error("树占比+水滴占比不能超过100%")
            return
          }
          if(radio < 100){
            this.$message.error("树占比+水滴占比必须等于100%")
            return
          }
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateLevel(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addLevel(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
